<template>
  <appQuoteEdit :propsMode="'edit'" :quoteType="'leads'"></appQuoteEdit>
</template>
<script>
import appQuoteEdit from '../../../components/quote/quoteEdit.vue'

export default {
  name: 'leadsEdit',
  components: {
    appQuoteEdit
  }
}
</script>